module.exports = __webpack_public_path__ + "img/e270dc0.svg";